module.exports = __webpack_public_path__ + "img/oufu_55x85x12.prt.f816b215.jpg";